export type MinData = { id: string }

/**
 * The column with this id will render smaller, centered text.
 * Ideally, this id is reserved for the first column.
 */
export const RANK = 'rank'
